<template>
    <div class="history-versions">
        <div class="history-section-label">Versions</div>

        <template v-if="loading">
            <div v-for="index in 4" :key="index" class="history-version skeleton">
                <div class="skeleton-circle"></div>
                <div>
                    <div class="skeleton-line w-25"></div>
                    <div class="skeleton-line w-75"></div>
                    <div class="skeleton-line w-50"></div>
                </div>
            </div>
        </template>

        <div
            v-else
            v-for="version in newestFirst"
            :key="version.number"
            class="history-version"
            :class="{ selected: version.number == selected }"
            role="button"
            @click="$emit('select', version)"
        >
            <c-avatar v-if="version.user" :name="version.user.name" small />
            <div v-else class="user-avatar sm"><div class="avatar"><span class="initials"><i class="far fa-user"></i></span></div></div>
            <div class="history-version-info">
                <div class="history-version-title">
                    v{{ version.number }}
                    <span v-if="version.current" class="badge rounded-pill history-pill">Current</span>
                </div>
                <div class="history-version-meta">
                    <template v-if="version.user">{{ version.user.name }} &middot; </template>{{ formatTime(version.at) }}
                </div>
                <div class="history-version-description">{{ version.description }}</div>
                <div v-if="version.counts" class="history-counts">
                    <span class="added">+{{ version.counts.added }}</span>
                    <span class="removed">−{{ version.counts.removed }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: {
            versions: { type: Array, default: () => [] },
            selected: Number,
            loading: Boolean
        },

        computed: {
            newestFirst () {
                return this.versions.slice().reverse()
            }
        },

        methods: {
            formatTime (value) {
                return moment(value).fromNow()
            }
        }
    }
</script>
